import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Stars } from "@/components/travel/Stars";
import BadgeList from "@/components/travel/BadgeList";
import { Award } from "lucide-react";

export default function Profile() {
  const { userId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/users/${userId}/profile`);
        setData(r.data);
      } catch (err) { console.error("profile load failed", err); }
    })();
  }, [userId]);

  if (!data) return <div className="p-8 text-center text-slate-400">Chargement…</div>;
  const u = data.user;

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="glass-strong rounded-2xl p-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-slate-800 flex items-center justify-center text-2xl font-bold">{u.name?.[0]}</div>
          <div className="flex-1">
            <h1 className="font-display text-2xl font-bold">{u.name}</h1>
            <div className="flex items-center gap-2 text-sm text-slate-400"><Stars value={u.rating_avg}/> {u.rating_avg}/5 · {u.rating_count} avis</div>
            {u.missions_completed > 0 && (
              <div className="text-xs text-[#F59E0B] mt-1 flex items-center gap-1"><Award size={12}/> {u.missions_completed} mission(s) complétée(s)</div>
            )}
            <div className="mt-2"><BadgeList badges={u.badges || []} size="md"/></div>
          </div>
        </div>
      </div>

      <h2 className="font-display text-lg font-bold mt-8 mb-3">Avis reçus</h2>
      <div className="space-y-2">
        {data.reviews.map(r => (
          <div key={r.review_id} className="glass rounded-xl p-4">
            <div className="flex justify-between items-center mb-1">
              <div className="text-sm font-semibold">{r.author?.name || "Anonyme"}</div>
              <Stars value={r.rating}/>
            </div>
            <p className="text-sm text-slate-300">{r.comment || <span className="text-slate-500 italic">Pas de commentaire</span>}</p>
          </div>
        ))}
        {data.reviews.length === 0 && <div className="text-sm text-slate-500">Aucun avis pour le moment.</div>}
      </div>
    </div>
  );
}
